import { CalendarToday } from '@mui/icons-material';
import { Tabs } from 'finara-components';
import type { TabItem } from 'finara-components';
import { useState } from 'react';

import { Navbar } from '@/components/super-admin/general/Navbar';
import { superAdminNavItems } from '@/data/super-admin/general/navigationData';
import { useAuth } from '@/hooks/useAuth';

import { CompanyReportsTab } from './components/CompanyReportsTab';
import { WorkerReportsTab } from './components/WorkerReportsTab';

type ReportsTab = 'company' | 'worker';

export const ReportsPage: React.FC = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState<ReportsTab>('company');

  const tabs: TabItem[] = [
    {
      id: 'company',
      title: 'Por Empresa',
      onSelect: () => setActiveTab('company'),
    },
    {
      id: 'worker',
      title: 'Por Trabajador',
      onSelect: () => setActiveTab('worker'),
    },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'company':
        return <CompanyReportsTab />;
      case 'worker':
        return <WorkerReportsTab />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar
        navItems={superAdminNavItems}
        userName={user?.name || 'Usuario'}
        activeItem="Reportes & Datos"
      />

      <div className="px-4 py-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-2xl font-bold text-brand-white">Reportes & Datos</h1>
            <p className="text-muted mt-1">
              Sistema centralizado de reportes, movimientos y análisis de cumplimiento con
              capacidades de exportación y programación automática.
            </p>
          </div>
          <div className="flex items-center space-x-2 text-sm text-muted">
            <CalendarToday fontSize="small" />
            <span>Diciembre 2024</span>
          </div>
        </div>

        {/* Tabs */}
        <div className="mb-6">
          <Tabs tabs={tabs} activeTabId={activeTab} />
        </div>

        {/* Tab Content */}
        {renderTabContent()}
      </div>
    </div>
  );
};
